<script>
import Translate from '@components/translate'

export default {
  components: { Translate },
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    }
  },
  data () {
    return {}
  },
  computed: {},
  mounted () {},
  methods: {}
}
</script>

<template>
  <div class="breadcrumb-wrapper">
    <span @click="$emit('back')">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:class="'icon-back'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M19 12H5M12 19l-7-7 7-7" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
      <h5>
        <Translate :directive="title ? title : 'profile.backlabel'"/>
      </h5>
    </span>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.breadcrumb-wrapper {
  margin-bottom: 3rem;

  span {
    align-items: center;
    display: flex;

    h5 {
      margin-bottom: 0;
    }

    h5:hover,
    img:hover {
      cursor: pointer;
    }

    .icon-back {
      margin-right: 1rem;
    }
  }
}
</style>
